import React, { useEffect, useMemo, useRef, useState } from 'react';
import './theme.less';
import './index.less';
import { Menu } from './Menu';
import { useScroll } from 'hooks/scroll';
import classNames from 'classnames';

export interface MarkdownPageProps {
    pageClassName: string;
    children: React.ReactChild;
    menuShow: boolean;
}

export default function MarkdownPage(props: MarkdownPageProps) {
    const bodyRef = useRef<HTMLDivElement>(null);

    const [menuList, setMenuList] = useState([]);
    const [nodeList, setNodeList] = useState<HTMLHeadElement[]>([] as any);
    function getMenuList() {
        const navList = bodyRef.current.querySelectorAll('h2,h3,h4');
        const menuList = [];
        const nodeList = [];
        navList.forEach((item) => {
            const level = Number(item.tagName.split('H')[1]);
            const hash = '#' + item.id;
            const title = item.textContent;
            menuList.push({
                level,
                hash,
                title,
            });
            nodeList.push(item);
        });
        setNodeList(nodeList);
        setMenuList(menuList);
    }
    useEffect(() => {
        getMenuList();
    }, []);

    const [showMenu, setShowMenu] = useState(true);
    // useScroll(() => {
    //     const menuRect = document.getElementById('md-menu')?.getBoundingClientRect();
    //     const footerRect = document.getElementById('home-footer')?.getBoundingClientRect();

    //     if (menuRect && footerRect && footerRect.top - menuRect.bottom < 50) {
    //         setShowMenu(false);
    //     } else {
    //         setShowMenu(true);
    //     }
    // }, 100);

    return (
        <div
            className={classNames('home-markdown', {
                current: props.menuShow,
            })}
        >
            <div className="md-view">
                <div className="md-menu-wrapper">
                    <Menu
                        nodeList={nodeList}
                        menuList={menuList}
                        className={props.pageClassName}
                        style={{
                            opacity: props.menuShow && showMenu ? 1 : 0,
                        }}
                    />
                </div>
                <div className="md-content">
                    <div className="md-body" ref={bodyRef}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
}
